/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'

import AuthLayout from './layouts/Auth'
import ErrorLayout from './layouts/Error'
import DashboardLayout from './layouts/Dashboard'
import DashboardView from './views/Dashboard'

const routes = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/tools" />,
    },
    {
        path: '/auth',
        component: AuthLayout,
        routes: [
            {
                path: '/auth/login',
                exact: true,
                component: lazy(() => import('views/Login')),
            },
            {
                path: '/auth/reset-password',
                exact: true,
                component: lazy(() => import('views/ResetPassword')),
            },
            {
                component: () => <Redirect to="/errors/error-404" />,
            },
        ],
    },
    {
        path: '/errors',
        component: ErrorLayout,
        routes: [
            {
                path: '/errors/error-401',
                exact: true,
                component: lazy(() => import('views/Error401')),
            },
            {
                path: '/errors/error-404',
                exact: true,
                component: lazy(() => import('views/Error404')),
            },
            {
                path: '/errors/error-500',
                exact: true,
                component: lazy(() => import('views/Error500')),
            },
            {
                component: () => <Redirect to="/errors/error-404" />,
            },
        ],
    },
    {
        route: '*',
        component: DashboardLayout,
        routes: [
            {
                path: '/users',
                exact: true,
                component: lazy(() => import('views/Users')),
            },
            {
                path: '/users/new',
                exact: true,
                component: lazy(() => import('views/NewUser')),
            },
            {
                path: '/users/:id',
                exact: true,
                component: lazy(() => import('views/User')),
            },
            {
                path: '/tools',
                exact: true,
                component: lazy(() => import('views/Tools')),
            },
            {
                path: '/tools/new',
                exact: true,
                component: lazy(() => import('views/NewTool')),
            },
            {
                path: '/tools/:alias',
                exact: true,
                component: lazy(() => import('views/Tool')),
            },
            {
                path: '/verify-payment',
                exact: true,
                component: lazy(() => import('views/VerifyPayment')),
            },
            {
                path: '/add-expiry-interval',
                exact: true,
                component: lazy(() => import('views/AddExpiryInterval')),
            },
            {
                path: '/bonus',
                exact: true,
                component: lazy(() => import('views/Bonus')),
            },
            {
                path: '/remove-days-from-users',
                exact: true,
                component: lazy(() => import('views/RemoveDaysFromUsers')),
            },
            {
                path: '/dashboard',
                exact: true,
                component: DashboardView,
            },
            {
                path: '/profile',
                exact: true,
                component: lazy(() => import('views/Profile')),
            },
            {
                path: '/settings',
                exact: true,
                component: lazy(() => import('views/Settings')),
            },
            {
                path: '/settings/:tab',
                exact: true,
                component: lazy(() => import('views/Settings')),
            },
            {
                path: '/access-subtool/:name',
                exact: true,
                component: lazy(() => import('views/AccessTool')),
            },
            {
                path: '/access-rdp/:name',
                exact: true,
                component: lazy(() => import('views/AccessTool')),
            },
            {
                component: () => <Redirect to="/errors/error-404" />,
            },
        ],
    },
]

export default routes
